export default {
  version: "1.0.52-80",
  rootURL:
    process.env.NODE_ENV === "production"
      ? "https://www.maunent.com"
      : "http://localhost:3000",
  shortcutRootURL:
    process.env.NODE_ENV === "production"
      ? "https://maunent.com"
      : "http://localhost:3000",
  sentry: {
    DSN: "https://f6be1f12f2e3444bafc08971fee643ab@o470160.ingest.sentry.io/5500431"
  },
  s3: {
    ADDRESS: "https://content.maunent.com",
    OUTFIT_IMAGE: "lk",
    ITEM_IMAGE: "it",
    PROFILE_IMAGE: "pr"
  },
  apiGateway: {
    ADDRESS: "https://api.maunent.com"
  },
  cognito: {
    USER_POOL_ID: "us-east-1_DYgyRRZMl",
    APP_CLIENT_ID: "1jobpo7m097ba2nfma7ppfbhuo",
    OAUTH_DOMAIN: "us-east-1dygyrrzml.auth.us-east-1.amazoncognito.com",
    OAUTH_REDIRECT_SIGN_IN: [
      "https://www.maunent.com/auth/callback",
      "http://localhost:3000/auth/callback"
    ],
    OAUTH_REDIRECT_SIGN_OUT: [
      "https://www.maunent.com/",
      "http://localhost:3000/"
    ],
    REGION: "us-east-1"
  },
  paypal: {
    client_id:
      "AegpSexLIHSpowp0sRfC1RLWQ5GHhogofprdkkezUlbcz9121dtyZQFoAZv3Q0HyIaOddCVKbnFF_fcH"
    // "AZtKAt93NQWIIDu9Mj7bem9FRzy7TwZxEFk6KXBKHj-5D1dKJw-1o9SLYcTFkbQdSs3l7f-CH8L1_Dm7" // Sandbox
  },
  googleAnalytics: {
    TAG_ID: "G-0GJN0MB461"
  },
  membership: {
    freeTrial: { duration: 14 },
    priceHistory: [
      /**
       * {
       *   originalPrice: <type:object>required, 정상 가격,
       *   discountedPrice: <type:object>null-able, 할인된 가격,
       *   paypalPlanId: <type:string>required, Paypal plan ID,
       *   saleEndDate: <type:string(ISOString)>null-able, 할인 가격이 있는 경우 할인의 종료일,
       *   validUntil: <type:string(ISOString)>required, 현재 가격 체계의 종료일, 기약없으면 "9999-01-01T00:00:00.000Z"
       * }
       */
      {
        originalPrice: { us_dollar: 6.99, kr_won: 6900 },
        discountedPrice: { us_dollar: 1.99, kr_won: 1900 },
        paypalPlanId: "P-0613685028433093LMXOHLFI",
        saleEndDate: "2026-01-26T07:00:00.000Z",
        validUntil: "2026-01-26T07:00:00.000Z"
      },
      {
        originalPrice: { us_dollar: 5.99, kr_won: 5900 },
        discountedPrice: { us_dollar: 2.99, kr_won: 2900 },
        paypalPlanId: "P-1J235647FP168420PNF3LQDQ",
        // paypalPlanId: "P-66G352737T138253XMXN76JQ", // Sandbox
        saleEndDate: null,
        validUntil: "9999-01-01T00:00:00.000Z"
      }
      // {
      //   originalPrice: { us_dollar: 6.99, kr_won: 6900 },
      //   discountedPrice: { us_dollar: 3.99, kr_won: 3900 },
      //   paypalPlanId: "P-0613685028433093LMXOHLFI",
      //   // paypalPlanId: "P-66G352737T138253XMXN76JQ", // Sandbox
      //   saleEndDate: null,
      //   validUntil: "9999-01-01T00:00:00.000Z"
      // }
    ]
  },
  /**
   * [api해시]
   */
  restApiPath: {
    ensureUserAccountAPI: () => `users`,
    getMyProfileAPI: () => `users/username/mine`,
    deleteMyAccountAPI: () => `users/username/mine`,
    activateAccountStatusAPI: () => `users/username/mine/account-status`,
    getOthersProfileAPI: ({ name }) => `users/username/${name}`,
    setProfileImageAPI: () => `users/profile-img`,
    editMyUsernameAPI: () => `users/username/mine/username`,
    editMyInfoAPI: () => `users/username/mine/info`,
    editMyPresetAPI: () => `users/username/mine/preset`,
    getMyUserHashAPI: () => `user-hash/mine`,
    getUsernameFromUserHashAPI: ({ userHash }) =>
      `users/username/user-hash/${userHash}`,
    getWhetherEmailExistAPI: ({ emailBase64 }) =>
      `users/validation/email/${emailBase64}`,
    getWhetherUsernameExistAPI: ({ username }) =>
      `users/validation/username/${username}`,
    getViewerLocationAPI: () => `users/viewerlocations`,
    setMyItemAPI: () => `items`,
    getMyItemInfoAPI: ({ itemHash }) => `items/item-hash/${itemHash}`,
    removeMyItemAPI: ({ itemHash }) => `items/item-hash/${itemHash}`,
    getItemMemosAPI: ({ itemHash }) => `items/item-hash/${itemHash}/memos`,
    setItemMemosAPI: ({ itemHash }) => `items/item-hash/${itemHash}/memos`,
    getMyWholeItemAPI: () => `items/username/mine`,
    getMyItemByCategoryAPI: ({ category }) =>
      `items/username/mine/category/${category}`,
    getCategoryOfMyItemAPI: () => `items/username/mine/category`,
    getItemOfOutfitAPI: ({ outfitHash }) => `items/outfit-hash/${outfitHash}`,
    getItemOfMyOutfitAPI: ({ outfitHash }) =>
      `items/outfit-hash/${outfitHash}/mine`,
    editItemOfOutfitAPI: ({ outfitHash }) =>
      `items/outfit-hash/${outfitHash}/mine`,
    setMyOutfitAPI: () => `outfits`,
    getMyOutfitAPI: () => `outfits/username/mine`,
    getBookmarkListAPI: () => `outfits/username/mine/bookmarked`,
    getFolderBookmarkListAPI: ({ bookmarkFolderHash }) =>
      `outfits/username/mine/bookmarked/folder-hash/${bookmarkFolderHash}`,
    getPickListAPI: () => `outfits/username/mine/picked`,
    getFolderPickListAPI: ({ pickFolderHash }) =>
      `outfits/username/mine/picked/folder-hash/${pickFolderHash}`,
    getOutfitOfMyFollowingsAPI: () => `outfits/username/mine/followings`,
    getOutfitOfUserAPI: ({ name }) => `outfits/username/${name}`,
    getOutfitOfUserForGuestAPI: ({ name }) =>
      `outfits/username/${name}/forguest`,
    getSearchedOutfitAPI: () => `outfits/search`,
    getSearchedOutfitForGuestAPI: () => `outfits/search/forguest`,
    getOutfitWithItemAPI: ({ itemHash }) => `outfits/item-hash/${itemHash}`,
    removeMyOutfitListAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}`,
    getInfoOfOutfitAPI: ({ outfitHash }) => `outfits/outfit-hash/${outfitHash}`,
    getCalendarOfOutfitAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}/calendar`,
    setMemoOfOutfitAPI: ({ date }) => `outfits/memos/date/${date}`,
    getBookmarkInfoOfOutfitAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}/bookmark`,
    getPickInfoOfOutfitAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}/pick`,
    getFollowingsAPI: () => `users/username/mine/followings`,
    makeRelationshipAPI: ({ target }) =>
      `users/username/mine/followings/target/${target}`,
    breakRelationshipAPI: ({ target }) =>
      `users/username/mine/followings/target/${target}`,
    checkRelationshipAPI: ({ target }) =>
      `users/username/mine/followings/target/${target}`,
    getFollowersAPI: () => `users/username/mine/followers`,
    getAutocompleteUsernameListAPI: ({ username }) =>
      `users/username/autocomplete/${username}`,
    getUrlForOutfitUploadAPI: () => `outfits/outfit-img-upload-url`,
    getUrlForItemUploadAPI: () => `items/item-img-upload-url`,
    getUrlForProfileUploadAPI: () => `users/profile-img-upload-url`,
    setBookmarkAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}/bookmark`,
    removeBookmarkAPI: ({ outfitHash }) =>
      `outfits/outfit-hash/${outfitHash}/bookmark`,
    setBookmarkToFolderAPI: ({ outfitHash, bookmarkFolderHash }) =>
      `outfits/outfit-hash/${outfitHash}/bookmark/folder-hash/${bookmarkFolderHash}`,
    removeBookmarkToFolderAPI: ({ outfitHash, bookmarkFolderHash }) =>
      `outfits/outfit-hash/${outfitHash}/bookmark/folder-hash/${bookmarkFolderHash}`,
    setPickAPI: ({ outfitHash }) => `outfits/outfit-hash/${outfitHash}/pick`,
    removePickAPI: ({ outfitHash }) => `outfits/outfit-hash/${outfitHash}/pick`,
    setPickToFolderAPI: ({ outfitHash, pickFolderHash }) =>
      `outfits/outfit-hash/${outfitHash}/pick/folder-hash/${pickFolderHash}`,
    removePickToFolderAPI: ({ outfitHash, pickFolderHash }) =>
      `outfits/outfit-hash/${outfitHash}/pick/folder-hash/${pickFolderHash}`,
    getGalleryListAPI: () => `outfits/username/mine/gallery`,
    setBrandTagAPI: () => `brands`,
    getAutocompleteBrandListAPI: ({ brandName }) =>
      `brands/autocomplete/${brandName}`,
    deleteUnlinkedCognitoUserAPI: () => `users/cognito/email`,
    setBookmarkFolderAPI: () => `bookmarks/folder`,
    removeBookmarkFolderAPI: ({ bookmarkFolderHash }) =>
      `bookmarks/folder/folder-hash/${bookmarkFolderHash}`,
    editBookmarkFolderAPI: ({ bookmarkFolderHash }) =>
      `bookmarks/folder/folder-hash/${bookmarkFolderHash}`,
    getBookmarkFolderListAPI: () => `bookmarks/folder/username/mine`,
    setPickFolderAPI: () => `picks/folder`,
    removePickFolderAPI: ({ pickFolderHash }) =>
      `picks/folder/folder-hash/${pickFolderHash}`,
    editPickFolderAPI: ({ pickFolderHash }) =>
      `picks/folder/folder-hash/${pickFolderHash}`,
    getPickFolderListAPI: () => `picks/folder/username/mine`,
    getLoungeListAPI: () => `outfits/lounge`,
    setFreeTrialAPI: () => `membership/username/mine/free-trial`,
    setPaidMembershipAPI: () => `membership/username/mine/paid-membership`,
    cancelPaidMembershipAPI: () =>
      `membership/username/mine/paid-membership/cancel`,
    getRefundInfoForPaidMembershipAPI: () =>
      `membership/username/mine/paid-membership/refund`,
    refundPaidMembershipAPI: () =>
      `membership/username/mine/paid-membership/refund`,
    getMyMembershipInfoAPI: () => `membership/username/mine`
  },
  /**
   * URL 은 MailRouter.js 와 하단 객체 두 파일의 값에 의존한다.
   */
  frontUrl: {
    opening: () => `/`,
    lookbook: () => `/lookbook`,
    outfit: arg1 => `/outfit/${arg1}`,
    itemDetail: arg1 => `/item/${arg1}`,
    search: () => `/search`,
    uploadOutfit: () => `/upload/outfit`,
    uploadItem: () => `/upload/item`,
    editProfileImage: () => `/upload/profile`,
    changePassword: () => `/change/password`,
    changeUsername: () => `/change/username`,
    account: () => `/account`,
    membership: () => `/membership`,
    about: () => `/about`,
    googleCallback: () => `/auth/callback`,
    terms: arg1 => `/terms-of-use/${arg1}`,
    privacy: arg1 => `/privacy-policy/${arg1}`,
    portfolio: arg1 => `/user/${arg1}`,
    shortcutOutfit: arg1 => `/o/${arg1}`,
    shortcutPortfolioHashType: arg1 => `/${arg1}`,
    shortcutPortfolioUsernameType: arg1 => `/u/${arg1}`
  },
  uploadImageQuality: {
    outfit: 0.81,
    item: 0.81,
    profile: 0.81
  },
  lengthOfHashtag: 5,
  outfitList: {
    LENGTH: 12
  },
  username: {
    maxLengthOfUsername: 30
  },
  itemList: {
    LENGTH: 25
  },
  followUser: { MAX_COUNT: 365 },
  followUserList: {
    LENGTH: 30
  },
  folderName: {
    MAX_LENGTH: 35
  },
  outfitImage: {
    RATIO: 10 / 16,
    THUMBNAIL_RATIO: 8 / 16,
    MAXIMUM_WIDTH: 1080,
    MINIMUM_WIDTH: 600,
    MAXIMUM_WIDTH_OF_THUMBNAIL: { desktop: 240, mobile: 150 }, // old: 80% of { desktop: 300, mobile: 200 }
    MAXIMUM_WIDTH_OF_THUMBNAIL_FOR_SMALL: { desktop: 150, mobile: 150 }
  },
  itemImage: {
    RATIO: 1 / 1,
    MAXIMUM_WIDTH: 640,
    MINIMUM_WIDTH: 200,
    MINIMUM_WIDTH_OF_THUMBNAIL: { desktop: 100, mobile: 76 }
  },
  profileImage: {
    RATIO: 1 / 1,
    MAXIMUM_WIDTH: 360,
    MINIMUM_WIDTH: 150
  },
  stickerImage: {
    RATIO: 900 / 180,
    heightRatio: 0.06 // 데일리룩 세로 이미지에 대한 스티커 이미지의 세로 비율.
  },
  storeModule: {
    waitForLoadingMilliSec: 200
  },
  listOfLocsInService: [
    "CA",
    "DE",
    "ES",
    "FR",
    "GB",
    "IT",
    "JP",
    "KR",
    "RU",
    "US"
  ],
  referralUrlQueryIndex: {
    refOutfit: "ref_outfit",
    refUsername: "ref_username"
  },
  iconDesign: {
    moreButton: "more"
  },
  cookieNameIndex: {
    itemDetailGuide: { name: "MaTooltipItemDetailGuide2", count: 2 },
    imgAddBtnGuide: { name: "MaTooltipAddImgBtnGuide", count: 5 }
  },
  css: {
    color: {
      colorOfBackground: "#ffffff",

      colorOfPrimary: "#F31D1D",
      colorOfVoteIcon: "#F31D1D",
      colorOfPick: "rgba(255,148,0,1)",
      backgroundColorOfSelectedItem: "rgba(255,255,255,0.4)",

      colorOfSecondary: "#808080",
      colorOfUnselect: "rgba(0, 0, 0, 0.46)",
      colorOfDisabled: "rgba(0, 0, 0, 0.26)",
      colorOfDanger: "#F31D1D", // 임시로 primary 와 같다.

      colorOfCommonIcon: "rgba(0, 0, 0, 0.54)",

      colorOfTooltipPrimary: "#f31d1dbd",

      backgroundColorOfHighlightContainedButton: "#F31D1D",
      colorOfHighlightContainedButton: "rgba(255, 255, 255, 1)",
      backgroundColorOfSelectContainedButton: "rgba(46, 46, 46, 1)",
      colorOfSelectContainedButton: "rgba(255, 255, 255, 1)",
      backgroundColorOfUnselectContainedButton: "rgba(0, 0, 0, 0.06)",
      colorOfUnselectContainedButton: "rgba(0, 0, 0, 0.87)",

      backgroundColorOfImage: "#e9e9e9",
      backgroundColorOfSecondPairImage: "#dedede",

      colorOfCard: "#f8f8f8",
      colorOfDropdown: "#fbfbfb",

      backgroundColorOfModal: "rgba(247, 247, 247, 0.85)",

      backgroundColorOfHighlightedListButton: "#e0e0e0",
      backgroundColorOfNormalListButton: "#f0f0f0",

      colorOfMainText: "rgba(0, 0, 0, 0.87)",
      colorOfMinorText: "rgba(0, 0, 0, 0.54)",

      colorOfNavBarBtnForGuest: "rgba(0, 0, 0, 0.62)",

      backgroundColorOfDownloadOutfit: "#ffffff",
      textColorOfDownloadOutfit: "rgba(0, 0, 0, 0.87)",

      colorOfBadge: "#f31d1d26"
    },
    zIndex: {
      snackbar: {
        cookieConsent: 4000,
        PWAInstallForAndroid: 4001,
        installGuideForIOS: 4002
      },
      header: {
        normal: 1000,
        customHeaderForMobile: 1001
      }
    },
    fontFamily: [
      `"Roboto"`,
      `"Noto Sans KR"`,
      `"Noto Sans JP"`,
      /** 하단 폰트는 각 디바이스, OS별 기본 폰트 */
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(", "),
    fontThickness: {
      /** 사용되지 않는 항목 있다면 font import 코드에서 수정하자. */
      /** 주석 처리된 weight는 죽어도 안쓸것 같고, 활성화된건 쓸수도 있을거 같아서 냅둠. */
      // thin: 100,
      // light: 300,
      regular: 400,
      medium: 500,
      bold: 700,
      black: 900,
      /**
       * 예전 스코어 있던시절 다운로드이미지에 사용하기위해 설정한 레거시 코드
       * (현재 아무의미없다)
       */
      forScoreOfDownloadImage: 900
    },
    animation: { modalDurationMilliSec: 225 },
    mobile: {
      logoBarHeightPX: 90,
      headerBarHeightPX: 60,
      sidePadding: 30,
      paddingBetweenHeaderbarAndFirstContent: 135,
      paddingBetweenHeaderbarAndFirstContentForOutfitDetail: 0,
      paddingBetweenHeaderbarAndFirstContentForLookbook: 105,
      paddingBetweenHeaderbarAndFirstContentForOutfitUpload: 50,
      paddingBetweenHeaderbarAndFirstContentForPortfolio: 50,
      paddingBetweenHeaderbarAndFirstContentForMembership: 80,
      paddingBetweenHeaderbarAndFirstContentForItemDetail: 50,
      minusPaddingBetweenContentsForOutfitUpload: 60 /** 모바일 아웃핏업로드중 아이템선택 화면에서 사용성 늘리기 위해 너무 긴 컨텐츠간 거리 줄이기 위한 변수 */,
      paddingBetweenTextButton: 30,
      standardPaddingBetweenContent: 120,
      paddingBetweenTextAndIcon: 5,
      paddingOfScrollEnd: 500,
      outfitUnit: {
        /** "side패딩" 대비 각 마진의 길이 비율 */
        rightMarginProportionToSidePadding: 0.5, // 예전 1
        bottomMarginProportionToSidePadding: 0.8 // 예전 1.6
      },
      itemUnit: {
        /** "유닛의 폭" 대비 각 마진의 길이 비율 */
        rightMarginProportionToImageWidth: 0.08,
        bottomMarginProportionToImageWidth: 0.16
      },
      sectionTitleFontSizePX: 30,
      sectionTitleBottomPadding: 76,
      fontSizeOfTextBtn: 14,
      fontSizeOfContainedBtn: 14,
      fontSizeOfAccountPanelBtn: 14,
      fontSizeOfItemDetail: {
        normalText: 12,
        brandText: 18
      }
    },
    desktop: {
      maximumWidth: 1220,
      minimumWidth: 650,
      headerBarHeightPX: 70,
      sidePadding: 50,
      paddingBetweenHeaderbarAndFirstContent: 150,
      paddingBetweenHeaderbarAndFirstContentForSplitView: 40,
      standardPaddingBetweenContent: 220,
      paddingBetweenTextButton: 30,
      iconButtonPadding: 12,
      paddingBetweenTextAndIcon: 5,
      paddingOfScrollEnd: 500,
      outfitUnit: {
        /** "side패딩" 대비 각 마진의 길이 비율 */
        rightMarginProportionToSidePadding: 1,
        bottomMarginProportionToSidePadding: 1.6
      },
      itemUnit: {
        /** "유닛의 폭" 대비 각 마진의 길이 비율 */
        rightMarginProportionToImageWidth: 0.12,
        bottomMarginProportionToImageWidth: 0.24
      },
      sectionTitleFontSizePX: 35,
      sectionTitleBottomPadding: 88,
      fontSizeOfTextBtn: 14,
      fontSizeOfContainedBtn: 14,
      fontSizeOfAccountPanelBtn: 14,
      fontSizeOfItemDetail: {
        normalText: 14,
        brandText: 24
      }
    },
    commonDevice: {
      scrollListenerOffset: 600,
      itemDetail: {
        maxWidthOfContentWithoutPadding: 500,
        outerPaddingOfContent: 24
      },
      dropdownListBtn: {
        topAndBottomPaddingOfBtn: 8,
        sidePaddingOfBtn: 14
      },
      listItemBtn: {
        topAndBottomPaddingOfBtn: 9,
        sidePaddingOfBtn: 14
      },
      folderListItemBtn: {
        topAndBottomPaddingOfBtn: 14,
        sidePaddingOfBtn: 14,
        rightIconMargin: 30
      },
      containedButton: {
        lineHeightOfContainedBtn: 1.3
      },
      textButton: {
        lineHeightOfTextBtn: 1.3,
        normalPaddingRight: 10,
        normalPaddingTop: 6,
        smallPaddingRight: 2,
        smallPaddingTop: 1,
        largePaddingRight: 16,
        largePaddingTop: 8
      }
    }
  },
  itemColorList: {
    white: { start: "#ffffff", end: "#f7f7f7" },
    gray: { start: "#f9f9f9", end: "#9a9696" },
    darkgray: { start: "#868282", end: "#3e3d3d" },
    black: { start: "#272727", end: "#000000" },
    beige: { start: "#e2c3ad", end: "#d69363" },
    brown: { start: "#bb7745", end: "#3e2a25" },
    ivory: { start: "#fdf8f0", end: "#f1e3cc" },
    khaki: { start: "#eae5d7", end: "#866f51" },
    olivegreen: { start: "#b8b990", end: "#4d5942" },
    mint: { start: "#e8ffee", end: "#37c9a9" },
    lightgreen: { start: "#fdff6b", end: "#8fd452" },
    green: { start: "#048c52", end: "#24280f" },
    skyblue: { start: "#d2e4ff", end: "#6b99ce" },
    blue: { start: "#6b85e9", end: "#2341b0" },
    navy: { start: "#1a3d6f", end: "#14325e" },
    yellow: { start: "#fffad7", end: "#efb72c" },
    coral: { start: "#f9928a", end: "#e84737" },
    burgundy: { start: "#c45a71", end: "#440000" },
    pink: { start: "#f4cec9", end: "#f52f67" },
    orange: { start: "#ffd39d", end: "#fa3d02" },
    red: { start: "#e80416", end: "#940712" },
    lavender: { start: "#e9e4e8", end: "#9c6fa9" },
    purple: { start: "#cc50c9", end: "#261a2e" }
  },
  itemCategoryTree: [
    {
      name: "root",
      child: [
        {
          name: "outerweargrp",
          child: [
            {
              name: "jacketsgrp",
              child: [
                {
                  name: "downjacketsgrp",
                  child: [{ name: "downjackets" }, { name: "downvests" }]
                },
                { name: "blazers" },
                {
                  name: "furjacketsgrp",
                  child: [{ name: "furjackets" }, { name: "furvests" }]
                },
                { name: "leatherjackets" },
                { name: "denimjackets" },
                {
                  name: "regularjacketsgrp",
                  child: [
                    { name: "regularjackets" },
                    { name: "regularvestjackets" }
                  ]
                }
              ]
            },
            {
              name: "coatsgrp",
              child: [
                { name: "downcoats" },
                { name: "furcoats" },
                { name: "leathercoats" },
                { name: "regularcoats" }
              ]
            }
          ]
        },
        {
          name: "topsgrp",
          child: [
            {
              name: "knitweargrp",
              child: [
                { name: "sweaters" },
                { name: "cardigans" },
                { name: "knitvests" }
              ]
            },
            {
              name: "poloshirtsgrp",
              child: [
                { name: "longsleevepoloshirts" },
                { name: "shortsleevepoloshirts" }
              ]
            },
            {
              name: "tshirtsgrp",
              child: [
                { name: "longsleevetshirts" },
                { name: "shortsleevetshirts" }
              ]
            },
            { name: "tanks" },
            { name: "shirts" },
            {
              name: "sweatshirtsgrp",
              child: [{ name: "sweatshirts" }, { name: "hoodies" }]
            }
          ]
        },
        {
          name: "bottomsgrp",
          child: [
            {
              name: "pantsgrp",
              child: [
                { name: "dresspants" },
                { name: "jeans" },
                {
                  name: "leggingsgrp",
                  child: [{ name: "leggings" }, { name: "leggingsshorts" }]
                },
                {
                  name: "trainingpantsgrp",
                  child: [{ name: "trainingpants" }, { name: "trainingshorts" }]
                },
                {
                  name: "regularpantsgrp",
                  child: [{ name: "regularpants" }, { name: "regularshorts" }]
                }
              ]
            },
            {
              name: "skirtsgrp",
              child: [
                { name: "regularshortskirts" },
                { name: "regularlongskirts" }
              ]
            }
          ]
        },
        {
          name: "allinonesgrp",
          child: [{ name: "regulardresses" }, { name: "regularjumpsuits" }]
        },
        {
          name: "footweargrp",
          child: [
            {
              name: "sneakersgrp",
              child: [
                { name: "lowtops" },
                { name: "hightops" },
                { name: "sandals" }
              ]
            },
            {
              name: "shoesgrp",
              child: [{ name: "shoes" }, { name: "boots" }]
            }
          ]
        },
        {
          name: "accsgrp",
          child: [
            { name: "bags" },
            { name: "headwear" },
            { name: "belts" },
            {
              name: "eyeweargrp",
              child: [{ name: "glasses" }, { name: "sunglasses" }]
            },
            {
              name: "legweargrp",
              child: [{ name: "socks" }, { name: "stockings" }]
            },
            { name: "gloves" },
            {
              name: "jewelrygrp",
              child: [
                { name: "rings" },
                { name: "bracelets" },
                { name: "necklaces" },
                { name: "earrings" },
                { name: "regularjewelry" }
              ]
            },
            { name: "watches" },
            { name: "scarfs" },
            { name: "ties" },
            { name: "regularaccs" }
          ]
        }
      ]
    }
  ],
  /** 다운운로드 이미지에서의 아이템목록 순서 정하는 배열 */
  itemOrderList: [
    "downcoats",
    "furcoats",
    "leathercoats",
    "regularcoats",
    "downjackets",
    "downvests",
    "blazers",
    "furjackets",
    "furvests",
    "leatherjackets",
    "denimjackets",
    "regularjackets",
    "regularvestjackets",
    "sweaters",
    "cardigans",
    "knitvests",
    "longsleevepoloshirts",
    "shortsleevepoloshirts",
    "longsleevetshirts",
    "shortsleevetshirts",
    "tanks",
    "shirts",
    "sweatshirts",
    "hoodies",
    "dresspants",
    "jeans",
    "leggings",
    "leggingsshorts",
    "trainingpants",
    "trainingshorts",
    "regularpants",
    "regularshorts",
    "regularshortskirts",
    "regularlongskirts",
    "regulardresses",
    "regularjumpsuits",
    "lowtops",
    "hightops",
    "sandals",
    "shoes",
    "boots",
    "bags",
    "headwear",
    "belts",
    "glasses",
    "sunglasses",
    "socks",
    "stockings",
    "gloves",
    "rings",
    "bracelets",
    "necklaces",
    "earrings",
    "regularjewelry",
    "watches",
    "scarfs",
    "ties",
    "regularaccs"
  ]
};
